export const ReviewEntity = {
	TARGET_INVESTMENT: "TARGET_INVESTMENT",
	INVESTMENT: "INVESTMENT",
	UNIVERSE: "UNIVERSE",
	BENCHMARK: "BENCHMARK",
} as const;

export type ReviewEntity = (typeof ReviewEntity)[keyof typeof ReviewEntity];
